import React from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { selectedCharacterAtom } from '../../../../atoms/v3/characterAtoms';
import { layoutModeAtom, showPersonalizationAtom } from '../../../../atoms/v3/uiAtoms';
import { navigateAtom } from '../../../../atoms/v3/navigationAtoms';

/**
 * 角色卡头像组件
 * 显示当前选中角色卡的头像，点击进入对话个性化设置
 */
export const CharacterAvatar: React.FC = () => {
  const selectedCharacter = useAtomValue(selectedCharacterAtom);
  const navigate = useSetAtom(navigateAtom);
  const layoutMode = useAtomValue(layoutModeAtom);
  const setShowPersonalization = useSetAtom(showPersonalizationAtom);

  const handleClick = () => {
    // 在桌面模式下，使用状态管理而不是路由
    if (layoutMode === 'desktop') {
      setShowPersonalization(true);
    } else {
      // 移动模式下使用路由
      navigate({ path: '/v3/chat-personalization-settings' });
    }
  };

  // 获取显示名称和头像
  const displayName = selectedCharacter?.name || '默认';
  const avatarLetter = displayName.charAt(0).toUpperCase();

  return (
    <button
      onClick={handleClick}
      className="w-8 h-8 rounded-full bg-ios-blue dark:bg-ios-dark-blue flex items-center justify-center text-white text-sm font-semibold overflow-hidden hover:opacity-80 transition-opacity active:scale-95 flex-shrink-0"
    >
      {selectedCharacter?.avatarUrl ? (
        <img
          src={selectedCharacter.avatarUrl}
          alt={displayName}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        avatarLetter
      )}
    </button>
  );
};
